import { createApp } from 'vue'
import App from './App.vue'
import { setupPlugins } from './utils/plugins'
import router from './router'
import './styles/common.css' // 添加通用样式导入

const app = createApp(App)

// 设置插件
setupPlugins(app)

// 使用路由
app.use(router)

app.mount('#app')
